var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDeposit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "leftmenu/funds/icon-deposit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "1.33055874e-13%",
    x2: "50%",
    y2: "104.53891%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.7,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb61a",
    stopOpacity: 0.995478029,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.00510638,8.99744681 C3.00510638,8.20085106 3.32170213,7.44 3.88340426,6.87829787 C4.44510638,6.31659574 5.21106383,6 6.00255319,6 L24.0025532,6 C24.7991489,6 25.56,6.31659574 26.1217021,6.87829787 C26.6834043,7.44 27,8.20595745 27,8.99744681 L27,16.4987234 L3,16.4987234 L3,8.99744681 L3.00510638,8.99744681 Z M20.2544681,10.4987234 C20.0553191,10.4987234 19.866383,10.5753191 19.7234043,10.7182979 C19.5804255,10.8612766 19.5038298,11.0502128 19.5038298,11.2493617 L19.5038298,12.7506383 C19.5038298,12.9497872 19.5804255,13.1387234 19.7234043,13.2817021 C19.866383,13.4246809 20.0553191,13.5012766 20.2544681,13.5012766 L23.2570213,13.5012766 C23.4561702,13.5012766 23.6451064,13.4246809 23.7880851,13.2817021 C23.9310638,13.1387234 24.0076596,12.9497872 24.0076596,12.7506383 L24.0076596,11.2493617 C24.0076596,11.0502128 23.9310638,10.8612766 23.7880851,10.7182979 C23.6451064,10.5753191 23.4561702,10.4987234 23.2570213,10.4987234 L20.2544681,10.4987234 Z M3.00510638,19.5012766 L3.00510638,21.0025532 C3.00510638,21.7991489 3.32170213,22.56 3.88340426,23.1217021 C4.44510638,23.6834043 5.21106383,24 6.00255319,24 L24.0025532,24 C24.7991489,24 25.56,23.6834043 26.1217021,23.1217021 C26.6834043,22.56 27,21.7940426 27,21.0025532 L27,19.5012766 L3.00510638,19.5012766 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-11.1%",
    width: "133.3%",
    height: "144.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "leftmenu/funds/icon-deposit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeposit);
export default __webpack_public_path__ + "static/media/icon-deposit.efa08516c57cc1758eb52473ba57af14.svg";
export { ForwardRef as ReactComponent };